import { render, staticRenderFns } from "./MurojaatMonitoring.vue?vue&type=template&id=2afb6810&scoped=true&"
import script from "./MurojaatMonitoring.vue?vue&type=script&lang=js&"
export * from "./MurojaatMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./MurojaatMonitoring.vue?vue&type=style&index=0&id=2afb6810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb6810",
  null
  
)

export default component.exports